import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { BaseArtifactFragment, CreateTransactionMutation, JobDetailsV2Fragment, UpdateTransactionMutation } from "graphql.generated";

import { ActionSource } from "../../state/action-sources";

export const JobFinancialsActions = createActionGroup({
  source: ActionSource.JOB_FINANCIALS,
  events: {
    'Transaction Invoice Tag Clicked': props<{ invoiceId: string }>(),
    'Transaction Remarks Toggled': props<{ transactionId: string }>(),
    'Transaction Row Clicked': props<{ transactionId: string }>(),
    'Add Invoice Button Clicked': emptyProps(),
    'Add Damage Button Clicked': emptyProps(),
    'Open Transactions Actions Menu Button Clicked': props<{ transactionId: string }>(),
    'Edit Transaction Menu Item Clicked': emptyProps(),
    'View Receipt Menu Item Clicked': emptyProps(),
    'Delete Transaction Menu Item Clicked': emptyProps(),
    'Open Damage Actions Menu Button Clicked': props<{ damageId: string }>(),
    'Edit Damage Menu Item Clicked': emptyProps(),
    'Delete Damage Menu Item Clicked': emptyProps(),
    'Create Transaction Success': props<{
      data: CreateTransactionMutation;
    }>(),
    'Update Transaction Success': props<{
      data: UpdateTransactionMutation;
    }>(),
    'Update Transaction Error': props<{
      error: Error;
    }>(),
    'Create Damage Success': props<{
      updatedJob: JobDetailsV2Fragment;
    }>(),
    'Create Damage Error': props<{
      error: Error;
    }>(),
    'Update Damage Success': props<{
      updatedJob: JobDetailsV2Fragment;
    }>(),
    'Update Damage Error': props<{
      error: Error;
    }>(),
    'Remove Damage Success': props<{
      updatedJob: JobDetailsV2Fragment;
    }>(),
    'Remove Damage Error': props<{
      error: Error;
    }>(),
    'Create Artifact Success': props<{
      artifact: BaseArtifactFragment,
      jobId: string,
    }>(),
    'Create Artifact Error': props<{
      error: Error;
    }>(),
    'Send Document Success': props<{
      jobId: string;
      artifactId: string;
    }>(),
    'Send Document Error': props<{
      error: Error;
      artifactId: string;
    }>(),
  },
});
